/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Objects of type TaskInfoUpdateMessage are sent to hub method named taskInfoUpdateMessage to the task creator user only (no broadcast group). Listen to it via `signalRHub.on('taskInfoUpdateMessage', (message: TaskInfoUpdateMessage) => {}`
 * Message is forwarded directly from Service Bus - it's currently the same type
 * @export
 * @interface TaskInfoUpdateMessage
 */
export interface TaskInfoUpdateMessage {
    /**
     *
     * @type {string}
     * @memberof TaskInfoUpdateMessage
     */
    taskInfoId?: string;
    /**
     *
     * @type {string}
     * @memberof TaskInfoUpdateMessage
     */
    deviceId?: string;
    /**
     *
     * @type {string}
     * @memberof TaskInfoUpdateMessage
     */
    deviceType?: TaskInfoUpdateMessageDeviceTypeEnum;
    /**
     *
     * @type {Date}
     * @memberof TaskInfoUpdateMessage
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof TaskInfoUpdateMessage
     */
    updatedAt?: Date;
    /**
     *
     * @type {string}
     * @memberof TaskInfoUpdateMessage
     */
    taskType?: TaskInfoUpdateMessageTaskTypeEnum;
    /**
     *
     * @type {string}
     * @memberof TaskInfoUpdateMessage
     */
    stage?: TaskInfoUpdateMessageStageEnum;
    /**
     *
     * @type {string}
     * @memberof TaskInfoUpdateMessage
     */
    userId?: string;
    /**
     *
     * @type {string}
     * @memberof TaskInfoUpdateMessage
     */
    result?: string;
    /**
     *
     * @type {string}
     * @memberof TaskInfoUpdateMessage
     */
    resultExtrasJson?: string;
    /**
     *
     * @type {string}
     * @memberof TaskInfoUpdateMessage
     */
    timeToLive?: string;
}

/**
 * @export
 */
export const TaskInfoUpdateMessageDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type TaskInfoUpdateMessageDeviceTypeEnum =
    (typeof TaskInfoUpdateMessageDeviceTypeEnum)[keyof typeof TaskInfoUpdateMessageDeviceTypeEnum];

/**
 * @export
 */
export const TaskInfoUpdateMessageTaskTypeEnum = {
    HardReset: "HardReset",
    SoftReset: "SoftReset",
    UpdateFirmware: "UpdateFirmware",
    UpdatePayMateFirmware: "UpdatePayMateFirmware",
    StartCharge: "StartCharge",
    StopCharge: "StopCharge",
    UnlockConnector: "UnlockConnector",
    TriggerMessage: "TriggerMessage",
    ClearChargingProfile: "ClearChargingProfile",
    DisableEnableCharging: "DisableEnableCharging",
    ChangeConfiguration: "ChangeConfiguration",
    ChangeExtendedConfiguration: "ChangeExtendedConfiguration",
    SendMessage: "SendMessage",
    DeviceAlert: "DeviceAlert",
    LimitChargeTransaction: "LimitChargeTransaction",
    SetDefaultChargingProfile: "SetDefaultChargingProfile",
    Activate: "Activate",
    SolarOverride: "SolarOverride",
    SetCentralSystemPassThrough: "SetCentralSystemPassThrough",
    PauseResumeChargeTransaction: "PauseResumeChargeTransaction",
    UpdatePayMateConnectorPricing: "UpdatePayMateConnectorPricing",
    SaveDeviceLogFiles: "SaveDeviceLogFiles",
    PowerOutageSchedule: "PowerOutageSchedule",
    GridPowerRestoredNotification: "GridPowerRestoredNotification",
    KickConnection: "KickConnection",
    GetConfiguration: "GetConfiguration",
    SetCoreConfiguration: "SetCoreConfiguration",
    GetDistributionBoardRemoteProfiles: "GetDistributionBoardRemoteProfiles",
    SetDistributionBoardRemoteProfile: "SetDistributionBoardRemoteProfile",
    ClearDistributionBoardRemoteProfile: "ClearDistributionBoardRemoteProfile",
    WatchBalenaDevice: "WatchBalenaDevice",
    UpdateSupervision: "UpdateSupervision",
    SetDisplayedPrice: "SetDisplayedPrice",
    GetDisplayedPrice: "GetDisplayedPrice",
    StartOcppLogUpload: "StartOcppLogUpload",
} as const;
export type TaskInfoUpdateMessageTaskTypeEnum =
    (typeof TaskInfoUpdateMessageTaskTypeEnum)[keyof typeof TaskInfoUpdateMessageTaskTypeEnum];

/**
 * @export
 */
export const TaskInfoUpdateMessageStageEnum = {
    Requested: "Requested",
    Started: "Started",
    Complete: "Complete",
    Failed: "Failed",
    Cancelled: "Cancelled",
} as const;
export type TaskInfoUpdateMessageStageEnum =
    (typeof TaskInfoUpdateMessageStageEnum)[keyof typeof TaskInfoUpdateMessageStageEnum];

/**
 * Check if a given object implements the TaskInfoUpdateMessage interface.
 */
export function instanceOfTaskInfoUpdateMessage(
    value: object,
): value is TaskInfoUpdateMessage {
    return true;
}

export function TaskInfoUpdateMessageFromJSON(
    json: any,
): TaskInfoUpdateMessage {
    return TaskInfoUpdateMessageFromJSONTyped(json, false);
}

export function TaskInfoUpdateMessageFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TaskInfoUpdateMessage {
    if (json == null) {
        return json;
    }
    return {
        taskInfoId: json["taskInfoId"] == null ? undefined : json["taskInfoId"],
        deviceId: json["deviceId"] == null ? undefined : json["deviceId"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        taskType: json["taskType"] == null ? undefined : json["taskType"],
        stage: json["stage"] == null ? undefined : json["stage"],
        userId: json["userId"] == null ? undefined : json["userId"],
        result: json["result"] == null ? undefined : json["result"],
        resultExtrasJson:
            json["resultExtrasJson"] == null
                ? undefined
                : json["resultExtrasJson"],
        timeToLive: json["timeToLive"] == null ? undefined : json["timeToLive"],
    };
}

export function TaskInfoUpdateMessageToJSON(
    value?: TaskInfoUpdateMessage | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        taskInfoId: value["taskInfoId"],
        deviceId: value["deviceId"],
        deviceType: value["deviceType"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        taskType: value["taskType"],
        stage: value["stage"],
        userId: value["userId"],
        result: value["result"],
        resultExtrasJson: value["resultExtrasJson"],
        timeToLive: value["timeToLive"],
    };
}
